// extracted by mini-css-extract-plugin
module.exports = {"tabDecorator":"tabDecorator__bcraj"};